/**
 * Eliminates signature lines, dash lines, underscore lines, and apostrophe-only lines from the input text.
 * Also removes excessive blank lines and trims the result for UI display.
 */
export function eliminateLinesAndSymbols(input: string): string {
  if (!input) return "";

  // Remove lines that are only dashes, underscores, apostrophes, asterisks, or backticks (2 or more)
  let output = input.replace(/^[ \t]*([-_'*`]{2,})[ \t]*$/gm, "");

  // Remove lines that are only whitespace
  output = output.replace(/^\s+$/gm, "");

  // Remove excessive blank lines (more than 2)
  output = output.replace(/\n{3,}/g, "\n\n");

  // Trim leading/trailing whitespace and newlines
  output = output.trim();

  return output;
}
